import { Button, Input } from "antd";
import classes from "./BankItemCollapseContent.module.css";
import { UI_ITODatePicker } from "../../../../../../UI_ITO/UI_ITODatePicker/UI_ITODatePicker";
import { ButtonProps } from "antd/lib";
import { IBankItemCollapseContentProps } from "../../../../../../interfaces/props/AdminAgentInfo/IBankCollapseContentProps";

export const BankItemCollapseContent = ({
  onClickShowChronology,
}: IBankItemCollapseContentProps) => {
  return (
    <>
      <div className={classes.bankForm}>
        <div className={classes.bankFormItem}>
          <label className={classes.bankFormItemLabel}>АВ от тарифа (%)</label>
          <Input size="large" />
        </div>

        <div className={classes.bankFormItem}>
          <label className={classes.bankFormItemLabel}>
            Базовое превышение
          </label>
          <Input size="large" />
        </div>

        <div className={classes.bankFormItem}>
          <label className={classes.bankFormItemLabel}>
            Дата начала действия нового значения
          </label>
          <UI_ITODatePicker className={classes.datePicker} />
        </div>
      </div>

      <Button
        className={classes.checkChronology}
        color="primary"
        variant="link"
        onClick={onClickShowChronology}
      >
        Посмотреть хронологию
      </Button>
    </>
  );
};
